import { render, staticRenderFns } from "./DatePickerDialog.vue?vue&type=template&id=2666ef76&scoped=true&"
import script from "./DatePickerDialog.vue?vue&type=script&lang=js&"
export * from "./DatePickerDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=2666ef76&scoped=true&lang=css&"
import style1 from "./DatePickerDialog.vue?vue&type=style&index=1&id=2666ef76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2666ef76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/mifos-vue-uat/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
installComponents(component, {VDatePicker})
